import {useEffect, useMemo, useState} from "react";
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import EditorButton from "../../../../../../components/reports/editor-report/editor-button.jsx";
import EditorInput from "../../../../../../components/reports/editor-report/editor-input.jsx";

export default function RegisterMethod({ data, setMode }) {
    const [callEditor, setCallEditor] = useState(false);

    const registerMethodChart = useMemo(() => {
        const source = data?.presentedBy || [];

        return {
            labels: source.map(item => item.presented),
            values: source.map(item => Number(item.qty || 0)),
        };
    }, [data]);

    useEffect(() => {
        GraphicUtils.barChart(
            "register-method-chart",
            registerMethodChart.values,
            registerMethodChart.labels,
        );
    }, [registerMethodChart]);

    return (
        <>
            <div className="chart-report">
                <div className="flex flex-row gap-2">
                    <span className="chart-title">Apresentado por</span>
                    <EditorButton callEditor={callEditor} setCallEditor={setCallEditor}/>
                </div>

                <div className="mt-3" id="register-method-chart"/>
            </div>

            <EditorInput callEditor={callEditor} setMode={setMode}/>
            <div className="chart-divisor"/>
        </>
    )
}